var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile2Line = function SvgFile2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.3 21H5.7A2.7 2.7 0 0 1 3 18.3V3.9a.9.9 0 0 1 .9-.9h12.6a.9.9 0 0 1 .9.9v10.8H21v3.6a2.7 2.7 0 0 1-2.7 2.7m-.9-4.5v1.8a.9.9 0 1 0 1.8 0v-1.8zm-1.8 2.7V4.8H4.8v13.5a.9.9 0 0 0 .9.9zm-9-11.7h7.2v1.8H6.6zm0 3.6h7.2v1.8H6.6zm0 3.6h4.5v1.8H6.6z"
  })));
};
export default SvgFile2Line;